// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"144":"195cdcce","156":"f09c7d68","326":"79d4df9f","488":"195cdcce","537":"f09c7d68","545":"195cdcce","854":"f09c7d68"}[chunkId] + ".css";
};